"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseWktPolygonString = parseWktPolygonString;
exports.convertWktStringToArrayOfPolygonCoordinates = convertWktStringToArrayOfPolygonCoordinates;
exports.formatCustomRegionPayload = exports.generateRandomId = exports.finishPolygon = void 0;

var _mapPositionUtils = require("./mapPositionUtils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Our custom regions are stored as "Wkts (Well known text string)"
 * https://cran.r-project.org/web/packages/wkt/vignettes/Introduction.html
 *
 * The shape of the string is as follows
 * POLYGON ((-122.429413 47.558274, -122.4198 47.674453, -122.239213 47.677689, -122.260499 47.564761, -122.429413 47.558274))
 *
 * or
 *
 * MULTIPOLYGON (((-122.28953693 47.61848362, -122.27820728 47.65295406, -122.19924304 47.64323986, -122.28953693 47.61848362)), ((-122.4629465 47.6341759, -122.43994387 47.6508306, -122.40938815 47.64134733, -122.4629465 47.6341759)))

 *
 * The function parses the string into an array of lat/lng coords like so
 *
 * [47.558274, -122.429413, 47.674453, -122.4198, 47.677689, -122.239213, 47.564761, -122.260499, 47.558274, -122.429413]
 * @param wktPolygon
 * @returns {number[]}
 */
// eslint-disable-next-line import/prefer-default-export
function parseWktPolygonString(wktPolygon) {
  return wktPolygon.match(/-?\d+\.\d+/g).reduce(function (accu, numStr, i, arr) {
    return i % 2 ? accu : [].concat(_toConsumableArray(accu), [parseFloat(arr[i + 1]), parseFloat(arr[i])]);
  }, []);
}
/**
 * Takes a single wkt polygon or a multi wkt polygon and converts it into an array of screen
 * XY polygons
 * @param wktPolygonString
 * @param gmap
 */


function convertWktStringToArrayOfPolygonCoordinates(wktPolygonString, gmap) {
  return wktPolygonString.match(/((-?\d+\.\d+[\s|,]*)+)/g).map(function (polyString) {
    return (0, _mapPositionUtils.convertPolygonToScreenXY)(parseWktPolygonString(polyString), gmap);
  });
}
/**
 * Takes a polygon then reduces the number of points it contains while still maintaining the
 * general shape. Also appends the first two points two the end in order to complete the shape.
 * @param {number[]} polygon
 * @param {number} tolerance The minimum distance between two points to be accepted into the
 * reduced polygon
 * @returns {number[]}
 */


var finishPolygon = function finishPolygon(polygon, tolerance) {
  var simplifiedPolygon = simplifiyPolygon(polygon, tolerance);
  return [].concat(_toConsumableArray(simplifiedPolygon), [simplifiedPolygon[0], simplifiedPolygon[1]]);
};
/**
 * Takes in a polygon array of screen x/y coordinates and reduces them to a smaller number of
 * points while still maintaining the general shape.
 *
 * We do this by starting with the first coordinate pair, then walking through the sets of
 * coordinates until we find the first pair that is more than the provided tolerance away from
 * the starting pair.
 *
 * That pair then becomes the new base pair, and we walk up the array from there until we find
 * the next pair that is an acceptable distance away
 *
 * @param {number[]} polygon - Array of pixel coordinates representing a polygon. Has the shape
 * [x1, y1, x2, y2, ..., xn, yn] <=> (x1, y1), (x2, y), ..., (xn, yn)
 * @param {number} tolerance - The minimum number of pixels two points must be apart to be an
 * acceptable line in the reduced set of points
 * @returns {number[]}
 */


exports.finishPolygon = finishPolygon;

function simplifiyPolygon(polygon, tolerance) {
  // Polygons require at least 3 distinct points which translates to a minimum
  if (!polygon || polygon.length < 6) {
    return [];
  } // Start with the first coordinate


  var _polygon = _slicedToArray(polygon, 2),
      baseCoordLat = _polygon[0],
      baseCoordLng = _polygon[1]; // Square tolerance to avoid expensive sqrt calculation when determining distance


  var squaredTolerance = tolerance * tolerance;
  return polygon.reduce(function (acc, pixel, index, array) {
    // If the distance between the current point and the base point is greater than the tolerance
    // eslint-disable-next-line no-restricted-properties
    if (index % 2 === 0 && Math.pow(array[index] - baseCoordLat, 2) + Math.pow(array[index + 1] - baseCoordLng, 2) > squaredTolerance) {
      // Save the point and make it the new base comparison
      baseCoordLat = array[index];
      baseCoordLng = array[index + 1];
      return [].concat(_toConsumableArray(acc), [baseCoordLat, baseCoordLng]);
    }

    return acc;
  }, [baseCoordLat, baseCoordLng]);
}

var generateRandomId = function generateRandomId() {
  return "_" + Math.random().toString(36).substr(2, 9);
};

exports.generateRandomId = generateRandomId;

var polygonToRegionString = function polygonToRegionString(polygon) {
  return polygon.reduce(function (acc, coord, index) {
    return index % 2 === 0 ? "" + acc + polygon[index] + "," + polygon[index + 1] + (index < polygon.length - 2 ? '|' : '') : acc;
  }, '');
};

var formatCustomRegionPayload = function formatCustomRegionPayload(polygons) {
  return polygons.reduce(function (acc, polygon, index) {
    return "" + acc + (index > 0 ? ':' : '') + polygonToRegionString(polygon);
  }, '');
};

exports.formatCustomRegionPayload = formatCustomRegionPayload;